/** biome-ignore-all lint/complexity/noStaticOnlyClass: Stateless API wrapper, static methods are sufficient. */
import { apiClient } from '../../ApiClient';
import { RequestTarget } from '../../types';
import type { ActorDto } from '../ActorsService/types';
import type {
	AgentCreatorSendActorEventRequest,
	AgentCreatorSendActorEventResponse,
	CreateTalkingHeadActorRequest,
	TalkingHeadActorCloneRequest,
	TalkingHeadActorEventRequest,
	TalkingHeadRequestConfig,
	TalkingHeadSendMessageRequest,
	TalkingHeadSettings,
	TalkingHeadSettingsRequest
} from './types';

export class TalkingHeadService {
	static cloneActorToVoice(
		data: TalkingHeadActorCloneRequest,
		config?: TalkingHeadRequestConfig
	): Promise<unknown> {
		return apiClient.post('talking-head/actor-clone', data, {
			...(config ?? {}),
			target: RequestTarget.Chat
		});
	}

	static getSettings(
		{ client_secret }: TalkingHeadSettingsRequest,
		config?: TalkingHeadRequestConfig
	): Promise<TalkingHeadSettings> {
		return apiClient.get('talking-head/chat-settings', {
			...(config ?? {}),
			params: {
				client_secret
			},
			target: RequestTarget.Chat
		});
	}

	static createActor(
		data: CreateTalkingHeadActorRequest,
		config?: TalkingHeadRequestConfig
	): Promise<ActorDto> {
		return apiClient.post<ActorDto>('talking-head/get-create-actor', data, {
			...(config ?? {}),
			target: RequestTarget.Chat
		});
	}

	static sendActorEvent(
		data: TalkingHeadActorEventRequest,
		config?: TalkingHeadRequestConfig
	): Promise<unknown> {
		return apiClient.post('talking-head/send-actor-event', data, {
			...(config ?? {}),
			target: RequestTarget.Chat
		});
	}

	static sendMessage(data: TalkingHeadSendMessageRequest): Promise<unknown> {
		return apiClient.post('talking-head/send-message', data, {
			target: RequestTarget.Chat
		});
	}

	static sendAgentCreatorActorEvent(
		data: AgentCreatorSendActorEventRequest,
		config?: TalkingHeadRequestConfig
	): Promise<AgentCreatorSendActorEventResponse> {
		return apiClient.post<AgentCreatorSendActorEventResponse>(
			'talking-head/agent-creator/send-actor-event',
			data,
			{
				...(config ?? {}),
				target: RequestTarget.Chat
			}
		);
	}
}
